import React from 'react';
import { PleaseWaitSpinner } from '../../../../jsxctl/utilctl';
import { SelectedTicketsOptions } from '../../../logic/models';
import { useIFrameResize } from '../../../logic/hooks/utils/use-iframe-resize';
import { useAddTicketsToCartStore, useBaseSiteStore } from '../../../stores';
import { useAddToCartRequest } from '../../../logic/hooks/ticketselection/use-add-to-cart-request';
import { AdvancedTicketSelection } from '../selecttickets/advanced-ticket-selection';

type TicketSelectionSearchPanelProps = {
    options?: SelectedTicketsOptions;
}

// INFO: New sale

export function TicketSelectionSearchPanel({options}: TicketSelectionSearchPanelProps) { 
    const integ = useBaseSiteStore(s => s.integ);
    const onPromoUpdated = useAddTicketsToCartStore(s => s.onPromoUpdatedCallback);
    const [ eventDate, fetchingEventDate ] = useAddTicketsToCartStore(s => [ s.eventDate, s.fetchingEventDate ]);
    // const isAPackageSale = useAddPackageToCartStoreExt(s => s.isAPackageSale);

    const [onContentChange] = useIFrameResize();


    const fakeAddToCartRequest = useAddToCartRequest();

    /**
     * We don't need to pass promoInfo to TicketSelection here, since the
     * promo proposal input control is available in "Your selection" part of new sale.
     */
    const ticketSelectionContent = eventDate && <AdvancedTicketSelection
        key="ticketSelection"
        maxQty={4}
        onPromoUpdated={onPromoUpdated}
        scheduleRange={options?.scheduleRange}
        clearPreviousSelection={options?.clearPreviousSelection}
        hideBestTicketSelection={true}
        integ={integ}
        onContentChange={onContentChange}
        addToCartRequest={fakeAddToCartRequest}
        useNewSale={true}
        onGoBackToSeatPlan={options?.onGoBackToSeatPlan}
    />;

    return (fetchingEventDate ? <PleaseWaitSpinner/> : ticketSelectionContent);
}